import React, { useEffect, useRef, useState } from "react";

//Import Breadcrumb
import { Avatar, Divider, FormControl, FormHelperText, FormLabel, Grid, IconButton, InputAdornment, OutlinedInput } from "@mui/material";
import moment from 'moment';
import { useNavigate, useParams } from "react-router-dom";
import { Card, CardBody, Container } from "reactstrap";
import Breadcrumbs from '../../../components/Common/Breadcrumb';
import Notification from '../../../components/Common/Notification';
import RadioButtonGroup from "../../../components/Form/RadioButtonGroup";

import { connect, useDispatch } from 'react-redux';
import LoadingDialog from "../../../components/Common/LoadingDialog";
import CustomButton from "../../../components/Form/CustomButton";
import CustomSelect from "../../../components/Form/CustomSelect";
import CustomTextField from "../../../components/Form/CustomTextField";
import Helpers from "../../../helpers/helpers";
import { addNewUser, getAttachment, getUserDetails, resetUserState, updatePwUser, updateUser, verify_admin } from "../../../store/actions";
import CheckBox from "../../../components/Form/CheckBox";



const AddUser = ({ type, userDetails, roleList, editUser, addUser, error, updatePassword, attachment }) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { ID } = useParams();
    const fileInputRef = useRef();

    const data = [
        { value: "1", label: "Active" },
        { value: "0", label: "Inactive" },
    ]
    const defaultValues = {
        name: "",
        email: "",
        phone: "",
        profile_photo: "",
        role_id: "-1",
        password: "",
        password_confirmation: "",
        status: "1",
        department: "",
        to_be_notified: 0,
        job_title: "",
    }
    const [notification, setNotification] = useState({
        open: false,
        msg: "",
        type: "success",
    });
    const [values, setFormValues] = useState(defaultValues);
    const [loading, setIsLoading] = useState(false);
    const [showPassword, setShowPassword] = useState(false);
    const [showRePassword, setShowRePassword] = useState(false);
    const [profileImg, setProfileImg] = useState();
    const [width, setWidth] = useState(window.innerWidth);

    useEffect(() => {
        const handleResize = () => {
            setWidth(window.innerWidth); // Update state when window resizes
        };
        window.addEventListener("resize", handleResize);
        return () => {
            window.removeEventListener("resize", handleResize); // Cleanup on unmount
        };
    }, [])

    // useEffect(() => {
    //     if (type === "Edit" && userDetails?.profile_photo_path && attachment?.code === 'success') {
    //         setProfileImg(attachment?.base64_data);
    //     } else {
    //         setProfileImg("");
    //     }
    // }, [attachment])

    useEffect(() => {
        if (type === "Edit") {
            if (ID) {
                dispatch(resetUserState());
                initData();
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (error?.length > 0 && editUser?.code === 'success') {
            setNotification({
                open: true,
                msg: error?.[0]?.password || error?.[0]?.confirm_password,
                type: "error",
            })
        } else if (editUser?.length === 0 && error?.length > 0) {
            setNotification({
                open: true,
                msg: error?.[0]?.message || "Please filled in all required fields",
                type: "error",
            })
        }
    }, [error])

    useEffect(() => {
        if (type === "Edit" && userDetails?.length !== 0) {
            const filtered = userDetails || []
            if (ID && filtered) {
                setFormValues((prevValues) => ({
                    ...prevValues,
                    name: filtered.name || "",
                    email: filtered.email || "",
                    phone: filtered.phone || "",
                    gender: filtered.gender || "-1",
                    role_id: filtered.role_id ? parseInt(filtered?.role_id) : -1,
                    status: filtered.status,
                    job_title: filtered.job_title,
                    profile_photo: filtered.profile_photo_path_base64 || "",
                    department: filtered.department,
                    to_be_notified: filtered.to_be_notified,
                }))

                if (filtered?.profile_photo_path) {
                    setProfileImg(filtered?.profile_photo_path_base64);
                } else {
                    setProfileImg("");
                }
            }
        }
    }, [userDetails]);

    useEffect(() => {
        if (type === "Edit") {
            if (editUser.code === "success") {
                setNotification({
                    open: true,
                    msg: "Updated Successfully",
                    type: "success",
                });
                dispatch(verify_admin());
                if (values.password && values.password_confirmation) {
                    dispatch(updatePwUser({ id: ID, data: { password: values.password, confirm_password: values.password_confirmation } }))
                } else {
                    dispatch(resetUserState());
                    initData();
                }
            }
        }
    }, [editUser]);

    useEffect(() => {
        if (updatePassword.code === "success") {
            setNotification({
                open: true,
                msg: "Updated Successfully",
                type: "success",
            });

            setFormValues((prevValues) => ({
                ...prevValues,
                password: "",
                password_confirmation: ""
            }))
            dispatch(resetUserState());
            initData();
        }
    }, [updatePassword])

    useEffect(() => {
        if (type === "Add") {
            if (addUser.code === "success") {
                setNotification({
                    open: true,
                    msg: "Added Successfully",
                    type: "success",
                })
                dispatch(resetUserState())
                navigate("/settings-users")
            }
        }
    }, [addUser]);

    const initData = () => {
        dispatch(getUserDetails({ id: ID }))
    }
    const isUrl = (str) => {
        return typeof str === "string" && str.startsWith("data:image/jpeg;base64");
    };

    const handleSubmit = async (type) => {
        if (type === "Add") {
            dispatch(addNewUser(values));
        } else if (type === "Edit") {
            let payload = { ...values };
            if (profileImg) {
                // if (isUrl(profileImg)) {
                payload.profile_photo = profileImg;
                // } else {
                //     payload.profile_photo = `data:image/jpeg;base64,${profileImg}`
                // }
            }

            const filteredValues = Object.fromEntries(
                Object.entries(payload).filter(([key, value]) => value !== "")
            );

            dispatch(updateUser({ id: ID, user: filteredValues }));
        }
    };

    const onChangeFile = (file) => {
        if (Helpers.isFileSizeValid(file)) {
            // Helpers.getPreviewBase64(file, (result) => {
            //     setProfileImg(result);
            // });
            Helpers.getBase64(file, (result) => {
                setProfileImg(result);
                setFormValues((prevValues) => ({
                    ...prevValues,
                    profile_photo: result
                }));
            });
        } else {
            setNotification({
                open: true,
                msg: "File size must be less than 1MB",
                type: 'warning'
            });
        }
        // Clear the upload file value
        fileInputRef.current.value = '';
    };
    return (
        <React.Fragment>
            {
                width <= 425 &&
                <div className="mobile-button-container">
                    <CustomButton
                        title={'Save'}
                        press={() => handleSubmit(type)}
                        height={40}
                        backgroundColor={'#101010'}
                        textColor={'white'}
                        width={'100%'}
                    />
                </div>
            }
            <div className="page-content">
                <Container fluid>
                    <LoadingDialog open={loading || !userDetails} />
                    <Notification notification={notification} setNotification={setNotification} />
                    <Breadcrumbs
                        backRoute={"/settings-users"}
                        breadcrumbItems={[{ title: "Users", link: "/settings-users" },
                        { title: type === "Add" ? "Add User" : "Edit User", link: "#" },
                        ]}
                    >
                        {
                            width > 425 &&
                            <CustomButton
                                title={'Save'}
                                press={() => handleSubmit(type)}
                                height={40}
                                backgroundColor={'#101010'}
                                textColor={'white'}
                            />
                        }
                    </Breadcrumbs>
                    {/* <Card className="p-3">
                        <CardBody> */}
                    <Grid container spacing={2}>
                        <Grid item sm={12} lg={8} pb={3}>
                            <Card className="p-3 px-2">
                                <CardBody>
                                    <div className="setting-header">BASIC INFO</div>
                                    <Divider className="my-2 mb-4" />
                                    <Grid container spacing={2}>
                                        <Grid item xs={12} sm={12}>
                                            <CustomTextField
                                                title={'Name'}
                                                values={values.name}
                                                onChange={(e) => setFormValues((prevValues) => ({
                                                    ...prevValues,
                                                    name: e
                                                }))}
                                                placeholder="Your Name"
                                                error={error && error?.[0]?.name}
                                            />
                                        </Grid>

                                        <Grid item xs={12} sm={6}>
                                            <CustomTextField
                                                title={'Email'}
                                                values={values.email}
                                                onChange={(e) => setFormValues((prevValues) => ({
                                                    ...prevValues,
                                                    email: e
                                                }))}
                                                placeholder="your.email@example.com"
                                                error={error && error?.[0]?.email}
                                            />
                                        </Grid>
                                        <Grid item xs={12} sm={6}>
                                            <CustomTextField
                                                title={'Phone number (Optional)'}
                                                values={values.phone}
                                                type="phone"
                                                onChange={(e) => setFormValues((prevValues) => ({
                                                    ...prevValues,
                                                    phone: e
                                                }))}
                                                placeholder="65123456789"
                                                error={error && error?.[0]?.phone}
                                            />
                                        </Grid>
                                        <Grid item xs={12} sm={6}>
                                            <CustomSelect
                                                title={'Role'}
                                                valueName={"id"}
                                                labelName={"name"}
                                                values={values?.role_id || '-1'}
                                                onChange={(e) => setFormValues((prevValues) => ({
                                                    ...prevValues,
                                                    role_id: e
                                                }))}
                                                placeholder={'Select one'}
                                                data={roleList}
                                                error={error && error?.[0]?.role_id}
                                            />
                                        </Grid>

                                        <Grid item xs={12} sm={6}>
                                            <CustomTextField
                                                title={'Department (Optional)'}
                                                values={values.department}
                                                onChange={(e) => setFormValues((prevValues) => ({
                                                    ...prevValues,
                                                    department: e
                                                }))}
                                                placeholder=""
                                                error={error && error?.[0]?.department}
                                            />
                                        </Grid>

                                        <Grid item xs={12} sm={12}>
                                            <CustomTextField
                                                title={'Job Title'}
                                                values={values.job_title}
                                                onChange={(e) => setFormValues((prevValues) => ({
                                                    ...prevValues,
                                                    job_title: e
                                                }))}
                                                placeholder="Your job title"
                                                subtitle={'As it\'s listed in their employment agreement.'}
                                                error={error && error?.[0]?.job_title}
                                            />
                                        </Grid>
                                    </Grid>
                                </CardBody>
                            </Card>

                            <Card className="p-3 px-2">
                                <CardBody>
                                    <div className="setting-header">LOGIN & SECURITY</div>
                                    <Divider className="my-2 mb-4" />

                                    <Grid container spacing={2}>
                                        <Grid item xs={12} sm={12}>
                                            <FormControl variant="standard" fullWidth>
                                                <FormLabel style={{ fontFamily: 'Manrope-Bold', fontSize: 14 }}>Password </FormLabel>
                                                <OutlinedInput
                                                    size="small"
                                                    value={values.password}
                                                    placeholder="Enter password"
                                                    type={showPassword ? 'text' : 'password'}
                                                    endAdornment={
                                                        <InputAdornment position="end">
                                                            <IconButton
                                                                aria-label="toggle password visibility"
                                                                onClick={(e) => setShowPassword((show) => !show)}
                                                                edge="end"
                                                            >
                                                                {showPassword ? <i className="font-size-24 ri-eye-line"></i> : <i className="ri-eye-close-line font-size-24"></i>}
                                                            </IconButton>
                                                        </InputAdornment>
                                                    }
                                                    onChange={(e) => {
                                                        setFormValues((prevValues) => ({
                                                            ...prevValues,
                                                            password: e.target.value,
                                                        }))
                                                    }}
                                                />
                                                {error && <FormHelperText sx={{ color: "red" }}>{error && error?.[0]?.password}</FormHelperText>}
                                            </FormControl>
                                        </Grid>
                                        <Grid item xs={12} sm={12}>
                                            <FormControl variant="standard" fullWidth>
                                                <FormLabel style={{ fontFamily: 'Manrope-Bold', fontSize: 14 }}>Confirm Password</FormLabel>
                                                <OutlinedInput
                                                    size="small"
                                                    value={values.password_confirmation}
                                                    placeholder="Confirm password"
                                                    type={showRePassword ? 'text' : 'password'}
                                                    endAdornment={
                                                        <InputAdornment position="end">
                                                            <IconButton
                                                                aria-label="toggle password visibility"
                                                                onClick={(e) => setShowRePassword((show) => !show)}
                                                                edge="end"
                                                            >
                                                                {showRePassword ? <i className="font-size-24 ri-eye-line"></i> : <i className="ri-eye-close-line font-size-24"></i>}
                                                            </IconButton>
                                                        </InputAdornment>
                                                    }
                                                    onChange={(e) => {
                                                        setFormValues((prevValues) => ({
                                                            ...prevValues,
                                                            password_confirmation: e.target.value,
                                                        }))
                                                    }}
                                                />
                                                {error && <FormHelperText sx={{ color: "red" }}>{error && error?.[0]?.confirm_password}</FormHelperText>}
                                            </FormControl>
                                        </Grid>
                                    </Grid>

                                </CardBody>
                            </Card>
                        </Grid>
                        <Grid container item sm={12} lg={type === 'add' ? 12 : 4}>
                            <Grid item xs={12} sm={12}>{
                            }
                                <Card className="p-3 px-2">
                                    <CardBody>
                                        <div className="setting-header">SETTINGS</div>
                                        <Divider className="my-2 mb-4" />
                                        <FormLabel style={{ fontFamily: 'Manrope-Bold', fontSize: 14 }}>Avatar</FormLabel>
                                        <Grid container display={'flex'} alignItems={'center'} justifyContent={'center'} spacing={2}>
                                            <Grid item lg={3} md={2} sm={2} xs={2} display={'flex'} justifyContent={'center'}>
                                                <Avatar
                                                    alt="Profile Pic"
                                                    src={Helpers.isValidURL(profileImg) ? profileImg : `data:image/jpeg;base64,${profileImg}`}
                                                    sx={{ width: 64, height: 64 }}
                                                    onChange={(e) => setProfileImg(e)}
                                                />
                                            </Grid>
                                            <Grid item lg={9} md={10} sm={10} xs={2}>
                                                <div className="d-flex mb-2">
                                                    <CustomButton
                                                        title={'Choose'}
                                                        press={() => document.getElementById("new-upload-file").click()}
                                                        backgroundColor={'#F2F2F2'}
                                                        textColor={'#101010'}
                                                        borderStyle={'1px solid #E3E8EE'}
                                                    />
                                                    {
                                                        profileImg &&
                                                        <CustomButton
                                                            title={'Remove'}
                                                            press={() => (setProfileImg(), setFormValues((prevValues) => ({
                                                                ...prevValues,
                                                                profile_photo: ""
                                                            })))}
                                                            backgroundColor={'white'}
                                                            textColor={'#101010'}
                                                            borderStyle={'1px solid #E3E8EE'}
                                                            marginLeft={5}
                                                        />
                                                    }
                                                    <input
                                                        type="file"
                                                        id={"new-upload-file"}
                                                        ref={fileInputRef}
                                                        style={{ display: 'none' }}
                                                        accept="image/png, image/jpeg"
                                                        onChange={(e) => onChangeFile(e.target.files[0])}
                                                    />
                                                </div>
                                                <div className="setting-desc">JPG or PNG, 1MB Max.</div>
                                                {error && <FormHelperText sx={{ color: "red" }}>{error && error?.[0]?.profile_photo}</FormHelperText>}
                                            </Grid>
                                        </Grid>
                                        <div className="mt-3">
                                            <RadioButtonGroup
                                                title="Account status"
                                                value={values.status}
                                                data={data}
                                                setValue={(e) => setFormValues((prevValues) => ({
                                                    ...prevValues,
                                                    status: e,
                                                }))}
                                                required="true"
                                                name="status"
                                            />
                                        </div>
                                        <div className="mb-2">
                                            <CheckBox
                                                label={'Notify me of incoming orders and enquiries'}
                                                values={values?.to_be_notified == 1 ? true : false}
                                                onChange={(e) => {
                                                    setFormValues((prevValues) => ({
                                                        ...prevValues,
                                                        to_be_notified: e?.target?.checked ? 1 : 0,
                                                    }))
                                                }}
                                            />
                                            {error && <FormHelperText sx={{ color: "red" }}>{error && error?.[0]?.confirm_password}</FormHelperText>}
                                        </div>

                                        {type === "Edit" &&
                                            <>
                                                {error && <FormHelperText sx={{ color: "red" }}>{error.status || ""}</FormHelperText>}
                                                <FormLabel style={{ fontFamily: 'Manrope-Bold', fontSize: 14 }}>Last logged in</FormLabel>
                                                <div>{userDetails?.last_logged_in ? <>{moment(userDetails?.last_logged_in).format("DD MMM YYYY")}, {moment(userDetails?.last_logged_in).format("hh:mm A")}</> : "-"}</div>

                                            </>}

                                    </CardBody>
                                </Card>

                            </Grid>
                        </Grid>
                    </Grid>
                    {/* </CardBody>
                    </Card> */}
                </Container>
            </div>
        </React.Fragment >
    );
};

function mapStateToProps({ User, General }) {
    return {
        userDetails: User.userDetails,
        roleList: General.roleList,
        addUser: User.addUser,
        editUser: User.editUser,
        error: User.error,
        attachment: General.attachment,
        updatePassword: User.updatePw
    };
}

export default connect(mapStateToProps)(AddUser);
